// Hooks
import { useEffect, useState } from 'react';

// Contentful
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { RENDER_DOCUMENT_OPTIONS } from '../../helpers/contentful';

const VacanciesBlock = (props) => {
  const { title, intro } = props;

  const [jobs, setJobs] = useState();
  useEffect(() => {
    fetch('https://boards-api.greenhouse.io/v1/boards/mutiny/jobs')
      .then((response) => response.json())
      .then((data) => {
        if (data.jobs) {
          setJobs(data.jobs);
        }
      });
  }, []);

  return (
    <>
      <div className="VacanciesBlock" id="VacanciesBlock">
        <div className="VacanciesBlock-inner">
          <div className="VacanciesBlock-wrapper">
            <div className="VacanciesBlock-copy">
              <h2 className="VacanciesBlock-title">{[documentToReactComponents(title, RENDER_DOCUMENT_OPTIONS)]}</h2>
              <div className="VacanciesBlock-description">
                {[documentToReactComponents(intro, RENDER_DOCUMENT_OPTIONS)]}
              </div>
            </div>
            <div className="VacanciesBlock-embed">
              <ul className="job-board-items">
                {jobs &&
                  jobs.map((j) => (
                    <li className="job-board-item">
                      <h3 className="job-board-title">
                        <a href={j.absolute_url}>{j.title}</a>
                      </h3>
                      <ul className="job-board-info">
                        <li className="job-board-location">{j.location?.name}</li>
                      </ul>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VacanciesBlock;
